import axios from 'axios';

export default class ListaProjetos {
    constructor() {
        this.section = document.querySelector('.modulo-lista_projetos');
        this.loading = document.querySelector('#loadingProjects');
        this.btnLoadMore = this.section.querySelector('#loadMoreProjects');

        this.btnCategories = this.section.querySelectorAll('.btnCategorie');
        this.selectCategorie = this.section.querySelector('#selectCategorie');

        this.pagina = 1;
        this.categorie = null;

        this.events();

        // restaurar estado caso exista hash #projetos e state salvo
        this.restoreState();
    }

    events() {
        // clique nos projetos → salva posição e estado
        document.addEventListener('click', (e) => {
            const link = e.target.closest('a[href]');
            if (link && link.closest('#listProjects')) {
                this.saveState();
                sessionStorage.setItem('scrollProjetos', window.scrollY);
            }
        });

        // Botão "carregar mais"
        this.btnLoadMore.addEventListener('click', () => {
            const activeBtn = Array.from(this.btnCategories).find(btn => btn.classList.contains('active'));
            const categorie = activeBtn ? activeBtn.getAttribute('data-categorie') : this.selectCategorie?.value || null;
            const nextPage = this.pagina + 1;
            this.pagina = nextPage;
            this.categorie = categorie;
            this.loadProjects(categorie, nextPage);
        });

        // Clique nos botões (desktop)
        this.btnCategories.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                this.btnCategories.forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                const categorie = btn.getAttribute('data-categorie');
                this.pagina = 1;
                this.categorie = categorie;
                this.loadProjects(categorie);
                if (this.selectCategorie) {
                    this.selectCategorie.value = categorie; // sincroniza select
                }
            });
        });

        // Change no select (mobile)
        if (this.selectCategorie) {
            this.selectCategorie.addEventListener('change', (e) => {
                const categorie = e.target.value;
                this.pagina = 1;
                this.categorie = categorie;
                this.loadProjects(categorie);
                // sincroniza botões
                this.btnCategories.forEach(b => {
                    b.classList.remove('active');
                    if (b.getAttribute('data-categorie') === categorie) {
                        b.classList.add('active');
                    }
                });
            });
        }
    }

    // salva estado no sessionStorage
    saveState() {
        const state = {
            pagina: this.pagina,
            categorie: this.categorie
        };
        sessionStorage.setItem('stateProjetos', JSON.stringify(state));
    }

    // restaura estado quando voltar para #projetos
    restoreState() {
        const state = sessionStorage.getItem('stateProjetos');

        if (state && location.hash === '#projetos') {
            const { pagina, categorie } = JSON.parse(state);
            this.pagina = 1;
            this.categorie = categorie;

            // sincroniza seleção de categoria
            if (categorie) {
                if (this.selectCategorie) this.selectCategorie.value = categorie;
                this.btnCategories.forEach(b => {
                    b.classList.remove('active');
                    if (b.getAttribute('data-categorie') === categorie) b.classList.add('active');
                });
            }

            // carrega páginas até a última
            const loadAllPages = async () => {
                for (let p = 1; p <= pagina; p++) {
                    await this.loadProjects(categorie, p);
                }

                // reposiciona scroll
                const savedScroll = sessionStorage.getItem('scrollProjetos');
                if (savedScroll) {
                    window.scrollTo({ top: parseInt(savedScroll, 10), behavior: 'instant' });
                    sessionStorage.removeItem('scrollProjetos');
                }

                // limpa estado
                sessionStorage.removeItem('stateProjetos');
            };

            loadAllPages();
        }
    }

    loadProjects(categorie, page = 1) {
        this.loading.classList.remove('hidden');

        return axios.post('/wp-json/domino/v1/projetos', {
            page: page,
            categorie: categorie
        })
        .then(response => {
            const data = response.data.projetos;
            const projetosContainer = this.section.querySelector('#listProjects');
            if (!projetosContainer) {
                console.error('Elemento #listProjects não encontrado.');
                return;
            }
            if (page === 1) {
                projetosContainer.innerHTML = '';
            }
            data.forEach(projeto => {
                const projetoHTML = this.templateProject(projeto);
                projetosContainer.insertAdjacentHTML('beforeend', projetoHTML);
            });
            this.pagina = page;

            if (data.length < 9) {
                this.btnLoadMore.classList.add('hidden');
            } else {
                this.btnLoadMore.classList.remove('hidden');
            }
        })
        .catch(error => {
            console.error('Erro ao carregar projetos:', error);
        })
        .finally(() => {
            if (page === 1 && location.hash !== '#projetos') {
                this.section.scrollIntoView({ behavior: 'smooth' });
            }
            this.loading.classList.add('hidden');
        });
    }

    templateProject(projeto) {
        return `
            <a href="${projeto.permalink}" class="group block overflow-hidden rounded-[1.25rem] border border-gray bg-dark">
                <picture class="block w-full xl:h-[21.625rem] h-[20rem] overflow-hidden">
                    <img src="${projeto.img}" alt="${projeto.title}" class="block w-full h-full object-cover object-center group-hover:scale-110 transition-all">
                </picture>
                <div class="p-7 flex flex-col gap-2">
                    <div class="text-greenLight uppercase text-xs font-medium">${projeto.cliente}</div>
                    <h3 class="text-white uppercase text-xl leading-tight font-normal">${projeto.title}</h3>
                </div>
            </a>
        `;
    }
}

// inicializa se existir a seção
if (document.querySelector('.modulo-lista_projetos')) {
    new ListaProjetos();
}
